import contractCategory from './contract-category'

export default {
  name: 'BaseInfoContract',
  path: 'contract',
  meta: {
    label: 'contract',
    auth: 'contract'
  },
  component: {
    name: 'Contract',
    render(c) {
      return c('router-view')
    }
  },
  children: [contractCategory]
}
